import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../utils/baseQuery";
import { Endpoints } from "./urls";
import type {
  IEmployeeActionCreateInput,
  IEmployeeActionApproveInput,
  IEmployeeActionRejectInput,
  IEmployeeActionListParams,
  IEmployeeActionListResponse,
} from "../types/employeeAction.types";
import { apiHelper } from "../utils/apiHelper";

export const EMPLOYEE_ACTION_TAGS = {
  list: "employee-action-list",
};

export const employeeActionApi = createApi({
  reducerPath: "employeeActionApi",
  baseQuery: baseQuery(),
  tagTypes: [EMPLOYEE_ACTION_TAGS.list],
  endpoints: (builder) => ({
    createEmployeeAction: builder.mutation<
      { actionId: string },
      IEmployeeActionCreateInput
    >({
      query: (body) => ({
        url: Endpoints.employeeAction.create,
        method: "POST",
        body,
      }),
      invalidatesTags: [EMPLOYEE_ACTION_TAGS.list],
    }),

    employeeActionList: builder.query<
      IEmployeeActionListResponse,
      IEmployeeActionListParams
    >({
      query: (params) => apiHelper(Endpoints.employeeAction.list, params),
      providesTags: [EMPLOYEE_ACTION_TAGS.list],
    }),

    approveEmployeeAction: builder.mutation<void, IEmployeeActionApproveInput>({
      query: (body) => ({
        url: Endpoints.employeeAction.approve,
        method: "POST",
        body,
      }),
      invalidatesTags: [EMPLOYEE_ACTION_TAGS.list],
    }),

    rejectEmployeeAction: builder.mutation<void, IEmployeeActionRejectInput>({
      query: (body) => ({
        url: Endpoints.employeeAction.reject,
        method: "POST",
        body,
      }),
      invalidatesTags: [EMPLOYEE_ACTION_TAGS.list],
    }),
  }),
});

export const {
  useCreateEmployeeActionMutation,
  useEmployeeActionListQuery,
  useApproveEmployeeActionMutation,
  useRejectEmployeeActionMutation,
} = employeeActionApi;
